<template>
  <div class="d-flex">
    <ul
      v-for="(group, i) in groupsColorCategory"
      :key="i"
      class="mt-5 ml-5 note-list">
      <li
        v-for="category in group"
        :key="category.id"
        class="d-flex align-center mb-1 font-size-smaller"
      >
        <div
          class="note-color mr-1"
          :class="{'note-color--empty': !category.color_code}"
          :style="{ backgroundColor: category.color_code ? category.color_code : '#e6e6e6'}"
        ></div>
        {{ category.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RevenueAndProfitStackedNotes',

  props: {
    colorCategories: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    groupsColorCategory () {
      const limit = 10
      return new Array(Math.ceil(this.colorCategories.length / limit))
        .fill([])
        .map((_, i) => {
          return this.colorCategories.slice(limit * i, limit * (i + 1))
        })
    }
  }
}
</script>

<style scoped>
ul {
  list-style: none;
}

.note-list {
  width: max-content;
}

.note-color {
  width: 15px;
  height: 15px;
}

.note-color.note-color--empty {
  border: 1px solid #e8e8e8;
  border-width: 1px;
  cursor: default;
  background: repeating-linear-gradient(45deg, #f3f3f3, #f3f3f3 3%, white 3%, white 6%);
}
</style>>
